export interface CtaLink {
	text: string;
	href: string;
	// Backend missing-input key that produced this CTA. Consumers may use this
	// to trigger an inline-edit modal instead of navigating to `href`.
	key: string;
}

interface CtaContext {
	assetId: string | number;
	assetTypeId: string | number | null | undefined;
	userType: string;
}

// Informational-only keys map to `null` — no actionable CTA. Backend
// currently emits these keys (mirrors the missingInputs taxonomy):
//   purchase_price, insufficient_spend_history            (Cost Pressure)
//   peer_group_too_small, peer_has_no_downtime_data       (Downtime)
//   install_date, life_expectancy, condition              (Remaining Life)
type CtaBody = Omit<CtaLink, 'key'>;

const CTA_RESOLVERS: Record<string, null | ((ctx: CtaContext) => CtaBody)> = {
	purchase_price: (ctx) => ({
		text: 'Set Purchase Price',
		href: `/${ctx.userType}/assets/edit/${ctx.assetId}`,
	}),
	install_date: (ctx) => ({
		text: 'Set Install Date',
		href: `/${ctx.userType}/assets/edit/${ctx.assetId}`,
	}),
	life_expectancy: (ctx) => ({
		text: 'Set Estimated Useful Life',
		href: `/${ctx.userType}/assets/edit/${ctx.assetId}`,
	}),
	// condition: (ctx) => ({
	// 	text: 'Set Condition',
	// 	href: `/buyer/assets/edit/${ctx.assetId}`,
	// }),
	// insufficient_spend_history: (ctx) => ({
	// 	text: 'Set Markup for Replacement',
	// 	href: ctx.assetTypeId
	// 		? `/buyer/assetTypes/detail/${ctx.assetTypeId}`
	// 		: '/buyer/assetTypes',
	// }),
	// peer_group_too_small: null,
	// peer_has_no_downtime_data: null,
};

export const ctaLinksFromMissingInputs = (
	keys: string[] | undefined | null,
	ctx: CtaContext
): CtaLink[] => {
	if (!keys || keys.length === 0) return [];
	const seen = new Set<string>();
	const links: CtaLink[] = [];
	keys.forEach((key) => {
		const resolver = CTA_RESOLVERS[key];
		if (!resolver) return;
		const resolved = resolver(ctx);
		if (seen.has(resolved.text)) return;
		seen.add(resolved.text);
		links.push({ ...resolved, key });
	});
	return links;
};
